import {default as vegaEmbed} from 'vega-embed';

export async function drawVis(targetElmQuery, spec) {
  try {
    let messageBox = document.querySelector(targetElmQuery).querySelector(".vegaEmbed-error")
    if (messageBox) {
      messageBox.remove();
    }
    await vegaEmbed( targetElmQuery, spec, {renderer: "svg", actions: false});
  } catch (error) {
    let targetElm = document.querySelector(targetElmQuery);
    targetElm.innerHTML = "";
    let messageBox = document.createElement("div");
    messageBox.classList.add("text-danger", "vegaEmbed-error");
    messageBox.innerHTML = error.message;
    targetElm.append(messageBox);
  }
}
